'use strict';
const _ = require('underscore'),
	observable = require('@mindmup/mapjs-core/src/util/observable'),
	formattedNodeTitle = require('@mindmup/mapjs-core/src/content/formatted-node-title'),
	FixedPoint = require('./fixed-point');

module.exports = function MeasuresContent(collaborationModel, configAttributeName, valueAttrName) {
	const self = observable(this),
		getMeasuresNames = function () {
			const activeContent = collaborationModel.getActiveContent(),
				value = activeContent && activeContent.getAttr(configAttributeName);
			if (!_.isArray(value)) {
				return [];
			}
			return value;
		};
	if (!collaborationModel || !configAttributeName || !valueAttrName) {
		throw 'invalid-args';
	}
	self.getMeasuresNames = getMeasuresNames;

	self.getRawData = function (filter) {
		const activeContent = collaborationModel.getActiveContent(),
			data = [],
			measures = activeContent && getMeasuresNames();
		if (!activeContent) {
			return data;
		}
		data.push(['Name'].concat(measures));
		activeContent.traverse(function (idea) {
			if (!filter || filter.predicate(idea)) {
				data.push([formattedNodeTitle(idea.title)]
					.concat(_.map(measures,
						function (measure) {
							const ideaMeasures = idea.getAttr(valueAttrName) || {},
								floatVal = ideaMeasures[measure] && parseFloat(ideaMeasures[measure]);
							if (floatVal !== undefined && !isNaN(floatVal)) {
								return floatVal;
							}
						})
					)
				);
			}
		});

		return data;
	};

	self.addUpMeasurementForAllNodes = function (measurementName) {
		const result = {},
			measurementValue = function (val) {
				if (!val) {
					return;
				}
				if (!isNaN(parseFloat(val))) {
					return parseFloat(val);
				} else {
					return 0;
				}
			},
			addUpMeasure = function (idea) {
				const measures = idea.getAttr(valueAttrName),
					measureVal =  measurementValue(measures && measures[measurementName]);
				let sum = new FixedPoint(),
					hasValue = false;
				if (measureVal !== undefined) {
					sum = new FixedPoint(measureVal);
					hasValue = true;
				}
				if (idea.ideas) {
					_.each(idea.ideas, function (subIdea) {
						if (result[subIdea.id] !== undefined) {
							hasValue = true;
							sum = sum.add(result[subIdea.id]);
						}
					});
				}
				if (hasValue) {
					result[idea.id] = sum.toString();
				}
			},
			activeContent = collaborationModel.getActiveContent();

		if (!activeContent || !measurementName) {
			return {};
		}
		activeContent.traverse(addUpMeasure, true);
		return result;
	};

	self.getMeasurementValues = function (filter) {
		const result = [],
			activeContent = collaborationModel.getActiveContent();
		if (!activeContent) {
			return result;
		}
		activeContent.traverse(function (idea) {
			const newVals = {};
			if (!filter || filter.predicate(idea)) {
				_.each(_.extend({}, idea.getAttr(valueAttrName)), function (val, key) {
					if (val === undefined) {
						return;
					}
					if (!isNaN(parseFloat(val))) {
						newVals[key] = parseFloat(val);
					}
				});
				result.push({
					id: idea.id,
					title: formattedNodeTitle(idea.title),
					values: newVals
				});
			}
		});
		return result;
	};
	self.addMeasure = function (measureName) {
		const measures = getMeasuresNames(),
			activeContent = collaborationModel.getActiveContent();
		if (!activeContent || !measureName || measureName.trim() === '') {
			return false;
		}
		measureName = measureName.trim();

		if (_.find(measures, function (measure) {
			return measure.toUpperCase() === measureName.toUpperCase();
		})) {
			return false;
		}
		activeContent.updateAttr(activeContent.id, configAttributeName, measures.concat([measureName]));
		return measureName;
	};
	self.removeMeasure = function (measureName) {
		const activeContent = collaborationModel.getActiveContent(),
			hasMeasureName = measureName && measureName.trim && measureName.trim().length,
			measures = hasMeasureName && activeContent && getMeasuresNames(),
			updated = measures && _.without(measures, measureName);
		if (!activeContent || !hasMeasureName) {
			return false;
		}
		if (_.isEqual(updated, measures)) {
			return;
		}
		activeContent.startBatch();
		activeContent.updateAttr(activeContent.id, configAttributeName, updated);
		activeContent.traverse(function (idea) {
			activeContent.mergeAttrProperty(idea.id, valueAttrName, measureName,  false);
		});
		activeContent.endBatch();
		return measureName.trim();
	};

	self.validate = function (value) {
		return !isNaN(parseFloat(value)) && isFinite(value);
	};

	self.setValue = function (nodeId, measureName, value) {
		const activeContent = collaborationModel.getActiveContent();
		if (!activeContent || !self.validate(value)) {
			return false;
		}
		return activeContent.mergeAttrProperty(nodeId, valueAttrName, measureName, parseFloat(value));
	};
	self.getTitle = function () {
		const activeContent = collaborationModel.getActiveContent(),
			rootId = activeContent && activeContent.getDefaultRootId(),
			rootNode = activeContent && rootId && activeContent.findSubIdeaById(rootId);
		return (rootNode && rootNode.title) || 'map measures';
	};
	collaborationModel.addEventListener('mm-active-content-changed', (content, isNewContent) => {
		if (content) {
			if (isNewContent) {
				self.dispatchEvent('measures-new-content-loaded');
			} else {
				self.dispatchEvent('measures-content-changed');
			}
		}

	});
};

